import { AppointmentID } from "./Appointment";
import { DealerLocationID } from "./DealerLocation";
import { InterventionID } from "./Intervention";

export type InterventionElementID = number;

export type InterventionElementCodeID = number;

export enum INTERVENTION_ELEMENT_TYPES {
  Task = 1,
  Labor = 2,
  Part = 3,
  Text = 4,
  Discount = 5,
  SmallPart = 6,
  Fee = 7,
  Rental = 8,
  Menu = 9
}

export enum INTERVENTION_ELEMENT_STATUSES {
  Undefined = 0,
  Open = 1,
  Reserved = 2,
  Issued = 3,
  Backorder = 4,
  Packed = 5,
  InTransit = 6,
  Delivered = 7,
  Cancelled = 8,
  Invoiced = 9,
  Credited = 10
}

export interface InterventionElement {
  created_on: string;
  updated_on: string;
  id: InterventionElementID; // Claire InterventionElement Identifier
  dms_nr: string; // DMS Identifier
  description: string; // Description of the Element
  price: number | null; // Price of the Element
  vat: number | null; // VAT
  quantity: number | null; // Quantity of the Element
  labor_minutes: number | null; // Set minutes for labor
  is_local: boolean; // The element was created in Claire
  element_type: INTERVENTION_ELEMENT_TYPES; // Type of the Element
  status: INTERVENTION_ELEMENT_STATUSES; // Status of the Element
  parent_dms_nr: string; // DMS Identifier of the parent of the Element
  brand_code: string; // The brand that this element is part of
  reference_code: string; // The code that this element is referred to in the DMS, helpful for finding parts.
  intervention_id: InterventionID; // Identifier of the intervention that this element compose
  appointment_id?: AppointmentID; // Appointment Identifier to the appointment this element was created for
  intervention_dms_nr?: string; // DMSNr of the intervention, so this element can be paired to its intervention
  intervention_code?: string; // The intervention code, usually defined as the menu code
  intervention_price?: number; // The amount of money to add to the intervention price
  parent_code?: string; // This helps identify which package based on it's code, is this elements parent
  dms_wo_number?: string; // The WONr of the appointment, so this element can be paired to its appointment
}

export interface InterventionElementCode {
  created_on: string;
  updated_on: string;
  id: InterventionElementCodeID; // Intervention element code identifier
  dealer_location_id: DealerLocationID; // Dealer Location identifier
  brand_code: string; // Brand code for element
  reference_code: string; // Reference code for labor/part/others
  element_type: INTERVENTION_ELEMENT_TYPES; // Type of the Element
  description: string; // Description of element
  last_appointment_date: string; // Appointment date of last usage
}
